// =====================================================================
// VueEnsemble.jsx — M-008 — lignes de tri (GRAV) + transporteurs + scannés
// =====================================================================
// Lecture des stats par ligne (/convoyeur/line-stats). Une ligne peut
// avoir PLUSIEURS transporteurs (ex: L1 = UPS + DHL + DPD). L7 = rejets.
// =====================================================================

import { useState, useEffect, useCallback } from 'react';
import { convoyeur as convoyeurApi } from '../../services/api.js';
import { CarrierChip, isOfflineError } from './styles.jsx';

export default function VueEnsemble() {
  const [lines, setLines] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    try {
      const d = await convoyeurApi.lineStats();
      const sorted = (d.lines || []).slice().sort((a, b) => a.line - b.line);
      setLines(sorted);
      setError(null);
    } catch (err) {
      setError(isOfflineError(err) ? 'Convoyeur hors-ligne — vue d\'ensemble indisponible.' : 'Erreur de chargement.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 5000);
    return () => clearInterval(t);
  }, [load]);

  const totalScanned = lines.reduce((a, l) => a + (l.scanned || 0), 0);

  if (loading) return <div style={{ padding: 40, textAlign: 'center', color: '#6b7280' }}>Chargement…</div>;
  if (error) return <div style={{ background: '#fef3c7', color: '#92400e', padding: '0.75rem 1rem', borderRadius: 6 }}>{error}</div>;

  return (
    <div>
      <div style={{ display: 'flex', gap: '1.5rem', flexWrap: 'wrap', padding: '0.625rem 0.875rem', background: '#f9fafb', borderRadius: 6, marginBottom: '1rem', fontSize: '0.8125rem', color: '#374151' }}>
        <span>🛤️ <strong>{lines.length}</strong> lignes de tri</span>
        <span>📦 Total scannés : <strong style={{ color: '#065f46' }}>{totalScanned}</strong></span>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(190px, 1fr))', gap: 14 }}>
        {lines.map((l, i) => {
          const carriers = (l.carriers && l.carriers.length) ? l.carriers : [l.carrier].filter(Boolean);
          const isReject = carriers.includes('Rejets') || carriers.includes('Autres');
          return (
            <div key={l.line} style={{
              border: '1px solid #e5e7eb', borderRadius: 12, background: '#fff', overflow: 'hidden',
              boxShadow: '0 1px 3px rgba(15,23,42,.06)',
            }}>
              <div style={{
                padding: '0.5rem 0.75rem', borderBottom: '1px solid #f1f5f9',
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                background: isReject ? '#fef2f2' : '#f8fafc',
              }}>
                <span style={{ fontWeight: 700, color: '#1e293b' }}>Ligne L{i + 1}</span>
                <span style={{ fontFamily: 'monospace', fontSize: '0.75rem', color: '#64748b' }}>GRAV {l.line}</span>
              </div>
              <div style={{ padding: '0.75rem' }}>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, minHeight: 26 }}>
                  {carriers.length ? carriers.map(c => <CarrierChip key={c} carrier={c} small />) : <span style={{ color: '#cbd5e1', fontSize: '0.8125rem' }}>—</span>}
                </div>
                <div style={{ marginTop: 12, display: 'flex', alignItems: 'baseline', gap: 6 }}>
                  <span style={{ fontSize: '1.6rem', fontWeight: 800, color: isReject ? '#b91c1c' : '#059669', lineHeight: 1 }}>{l.scanned || 0}</span>
                  <span style={{ fontSize: '0.75rem', color: '#94a3b8' }}>colis</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <p style={{ color: '#9ca3af', fontSize: '0.75rem', marginTop: 12 }}>
        Mise à jour automatique toutes les 5 s · les compteurs reflètent les colis attendus par transporteur (Effitrace).
      </p>
    </div>
  );
}
